import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IdraLoadingBar } from '@core/ui';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, IdraLoadingBar],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <idra-loading-bar />
    <router-outlet />
  `,
})
export class App {}
